export { default as DataErrorImg } from './data-error.webp';
export { default as NoDataImg } from './img_data_cancel.webp';
